var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.752 17.7529H6.25L6.04395 17.7471C3.93057 17.6398 2.25 15.892 2.25 13.752V6.25C2.25 4.04086 4.04086 2.25 6.25 2.25H13.7529L13.958 2.25488C16.0716 2.36187 17.7529 4.1098 17.7529 6.25V13.7529L17.7471 13.958C17.6435 16.0035 16.0035 17.6435 13.958 17.7471L13.752 17.7529ZM13.752 16.2529H6.25C4.86929 16.2529 3.75 15.1327 3.75 13.752V6.25C3.75 4.86929 4.86929 3.75 6.25 3.75H13.7529C15.1334 3.75026 16.2529 4.86945 16.2529 6.25V13.7529C16.2527 15.1334 15.1325 16.2529 13.752 16.2529Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7494 21.7503H10.2475L10.0414 21.7444C8.45266 21.6638 7.10849 20.656 6.53906 19.2514H8.24858C8.70476 19.8579 9.43035 20.2503 10.2475 20.2503H17.7494C19.13 20.2503 20.2502 19.1308 20.2504 17.7503V10.2474C20.2504 9.43075 19.8587 8.70559 19.253 8.24936V6.53906C20.7175 7.13328 21.7504 8.56981 21.7504 10.2474V17.7503L21.7446 17.9554C21.641 20.0009 20.001 21.6409 17.9555 21.7444L17.7494 21.7503Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.fe94ce76d421297c03ad1fb202b92f71.svg";
export { ForwardRef as ReactComponent };